<template>
  <div class="section">
    <h1>
      <span class="section-title">{{ $t('paymentfailed.title') }}</span>
      <span class="section-description">{{ $t('paymentfailed.description') }}</span>
    </h1>
    <p class="margin-top-30px" v-html="$t('paymentfailed.body1')"></p>
    <div class="margin-top-30px">
      <b-button v-if="$store.state.isPremium || $store.state.isBusiness || $store.state.isAPIUser" class="is-primary has-text-weight-bold" rounded
                @click="StripeCustomerPortal">
        {{ $t('paymentfailed.do') }}
      </b-button>
      <b-button v-if="!$store.state.isLoggedIn" class="is-info has-text-weight-bold" rounded>
        {{ $t('paymentfailed.need-login') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import { useSeoHead } from "@/helpers/seo";

export default {
  name: "PaymentFailed",
  created() {
    useSeoHead({
      base: '/payment-failed',
      locale: this.$i18n.locale,
      title: `${this.$t('paymentfailed.title')} | ${appConfig[this.$i18n.locale].title}`,
      description: appConfig[this.$i18n.locale].description.paymentfailed,
      noindex: true,
    })
  }
}
</script>

<style scoped>

</style>
